<template>
  <MainLayout>
    <b-row>
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />
          <b-alert
            v-show="passwordChangeSuccess"
            variant="success"
            show
          >
            Passwort wurde erfolgreich geändert.
          </b-alert>
          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Passwort ändern
          </h4>

          <div id="col-12">
            <form @submit.prevent="changePassword">
              <div class="form-group">
                <b-container class="pb-0 pt-0">
                  <b-row>
                    <label
                      for="filter"
                      class="pl-0 col-3 defaultLabel"
                    >Aktuelles Passwort</label>
                    <div class="col-9 pl-0">
                      <v-flex sm6>
                        <v-text-field
                          id="currentPasswordInput"
                          v-model="currentPassword"
                          :type="showCurrentPassword ? 'text' : 'password'"
                          name="input-10-2"
                          label="aktuelles Passwort"
                          class="input-group--focused"
                          :append-icon="
                            showCurrentPassword
                              ? 'visibility'
                              : 'visibility_off'
                          "
                          @click:append="
                            showCurrentPassword = !showCurrentPassword
                          "
                        />
                      </v-flex>
                    </div>
                  </b-row>
                </b-container>
              </div>
              <div class="form-group">
                <b-container class="pb-0 pt-0">
                  <b-row>
                    <label
                      for="filter"
                      class="pl-0 col-3 defaultLabel"
                    >Neues Passwort</label>
                    <div class="col-9 pl-0">
                      <v-flex sm6>
                        <v-text-field
                          id="newPasswordInput"
                          v-model="newPassword"
                          :type="shownewPassword ? 'text' : 'password'"
                          name="input-10-2"
                          label="neues Passwort"
                          class="input-group--focused"
                          :append-icon="
                            shownewPassword ? 'visibility' : 'visibility_off'
                          "
                          @click:append="shownewPassword = !shownewPassword"
                        />
                      </v-flex>
                    </div>
                  </b-row>
                </b-container>
              </div>
              <div class="form-group">
                <b-container class="pb-0 pt-0">
                  <b-row>
                    <label
                      for="filter"
                      class="pl-0 col-3 defaultLabel"
                    >Neues Passwort bestätigen</label>
                    <div class="col-9 pl-0">
                      <v-flex sm6>
                        <v-text-field
                          id="newPasswordConfirmedInput"
                          v-model="newPasswordConfirmed"
                          :type="shownewPasswordConfirmed ? 'text' : 'password'"
                          name="input-10-2"
                          label="neues Passwort bestätigen"
                          class="input-group--focused"
                          :append-icon="
                            shownewPasswordConfirmed
                              ? 'visibility'
                              : 'visibility_off'
                          "
                          @click:append="
                            shownewPasswordConfirmed = !shownewPasswordConfirmed
                          "
                        />
                      </v-flex>
                    </div>
                  </b-row>
                </b-container>
              </div>
              <b-btn
                variant="success"
                type="submit"
              >
                Passwort ändern
              </b-btn>
            </form>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import { UpdatePassword } from "@/services/user.service.js";

export default {
  components: {
    MainLayout,
  },
  data() {
    return {
      passwordChangeSuccess: false,
      currentPassword: "",
      newPassword: "",
      newPasswordConfirmed: "",
      showCurrentPassword: false,
      shownewPassword: false,
      shownewPasswordConfirmed: false,
      errorObject: null,
    };
  },
  methods: {
    changePassword() {
      this.passwordChangeSuccess = false;
      this.errorObject = null;

      UpdatePassword(
        this.currentPassword,
        this.newPassword,
        this.newPasswordConfirmed,
        () => {
          this.passwordChangeSuccess = true;

          this.currentPassword = "";
          this.newPassword = "";
          this.newPasswordConfirmed = "";
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style>
.v-treeview > .v-treeview-node--leaf {
  margin-left: 21px !important;
}
.v-icon.v-icon.v-icon--link {
  margin-left: 6px !important;
}
.formValidationError {
  color: red;
}
</style>
